/* eslint-disable no-debugger */
import useClubMultiSelect from './UseClubMultiSelect';

import MultiSelect from '../MultiSelect';

import global from '../../GlobalStyle.module.css';

const ClubMultiSelect = ({ label, name, value, error, message, onChange, filterIds="" }) => {
  const { activeClubsState, options } = useClubMultiSelect(filterIds);

  return activeClubsState.message
    ? <span className={global.LoadingMsg}>{activeClubsState.message}</span>
    : (
      <MultiSelect
        label={label}
        name={name}
        value={value}
        options={options}
        error={error}
        message={message}
        isLoading={activeClubsState.isLoading}
        onChange={onChange} />
    );
};

export default ClubMultiSelect;